import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from '@/store'

import '@/assets/js/rem.js'
import '@/assets/css/layout.scss'

import preventReClick from '@/utils/click'
import initShowToast from '@/utils/toast'

createApp(App)
.use(router)
.use(store)
.use(preventReClick)
.use(initShowToast)
.mount('#app')
